import '../scss/app.scss';

import 'regenerator-runtime/runtime.js';
import UIkit from 'uikit';
// const Icons = require('./../../../global/assets/svg-icons');

const modalTemplate = require('components/organisms/o-modal/o-modal.template.twig');

import ControllerProxy from '@global/js/ControllerProxy';
import Controller from './controller';

class App {
	state = {};
	dataEndpointsId = 'data-endpoints';
	globalModalContainerId = 'global-modal-container';
	dynamicModalContentPrefix = 'dynamic-modal-content--';
	registrableRemoteComponentsPrefixes = {
		layoutModal: '#layout-',
		wolfLayerModal: '#wolf-layer-',
		dynamicModal: '#dynamic-modal-',
		navCanvas: '#nav-offcanvas--',
	};

	constructor() {
		// loads the uikit icon plugin
		// UIkit.use(Icons);
		// initialize custom component js
		document.addEventListener('DOMContentLoaded', this.domReady.bind(this));
	}

	domReady() {
		this.getAppData();
		this.initComponents();
		this.registerModalOpeners();
		this.registerCanvasOpeners();
	}

	getAppData() {
		const endpointsData = document.getElementById(this.dataEndpointsId);
		if (endpointsData) {
			const endpoints = JSON.parse(endpointsData.innerText);
			this.state.endpoints = endpoints;
		}
	}

	initComponents() {
		const components = document.querySelectorAll('[data-controller]');

		components.forEach((el) => {
			const componentName = el.dataset.controller;
			new ControllerProxy(Controller, componentName, el);
		});
	}

	parseStringToNode(string) {
		return new DOMParser().parseFromString(string, 'text/html').body.firstChild;
	}

	async printDynamicModalOnScreen(contentId) {
		const newModalTriggerHref = this.registrableRemoteComponentsPrefixes.dynamicModal + contentId;
		const newModalId = newModalTriggerHref.substring(1);
		const newModalContentId = 'content--dynamic-modal-' + contentId;

		const modalIdHasBeenAlreadyRendered = !!document.getElementById(newModalId);
		if (modalIdHasBeenAlreadyRendered) return UIkit.modal(newModalTriggerHref).show();

		const loadingDataModal = {
			id: newModalId,
			content: `<div class="uk-flex uk-flex-center uk-magin-large"><span uk-spinner="ratio: 3"></span></div>`,
			closeButton: {
				text: '',
				type: 'default',
				title: 'Button title',
			},
			closeButtonPosition: 'top',
			width: 'half',
			modalPosition: 'right',
		};

		const modalContainer = document.getElementById(this.globalModalContainerId);
		const modalAsAString = modalTemplate({ data: loadingDataModal });
		const modalFragment = this.parseStringToNode(modalAsAString);

		modalContainer.innerHTML = '';
		modalContainer.appendChild(modalFragment);

		UIkit.modal(newModalTriggerHref).show();

		const getModalContent = async () => {
			try {
				const response = await fetch(this.state.endpoints.dynamicModal + `?contentId=${contentId}`);
				const modalResponse = await response.json();
				return modalResponse.content;
			} catch (e) {
				// console.log(e);
			}
		};

		const modalContentAsString = await getModalContent();
		const safeModalContentAsHTML = this.parseStringToNode(`<div>${modalContentAsString}</div>`);
		const modalContentElement = document.getElementById(newModalContentId);
		modalContentElement.innerHTML = '';
		modalContentElement.appendChild(safeModalContentAsHTML);
	}

	registerRemoteControlledComponent(hashtagIdPrefix, eventToListen, callback) {
		const controlledComponentNodesList = [...document.querySelectorAll(`a[href^='${hashtagIdPrefix}']`)];
		controlledComponentNodesList.forEach(function (value) {
			value.addEventListener(eventToListen, (e) => {
				e.preventDefault();
				let cleanId = value.getAttribute('href')?.split(hashtagIdPrefix)[1];
				callback(cleanId);
			});
		});
	}

	registerModalOpeners() {
		this.registerRemoteControlledComponent(this.registrableRemoteComponentsPrefixes.layoutModal, 'click', (name) =>
			UIkit.modal('#' + name).show(),
		);
		this.registerRemoteControlledComponent(this.registrableRemoteComponentsPrefixes.wolfLayerModal, 'click', (name) =>
			UIkit.modal('#' + name).show(),
		);
		this.registerRemoteControlledComponent(this.registrableRemoteComponentsPrefixes.dynamicModal, 'click', (name, dataset) =>
			this.printDynamicModalOnScreen(name),
		);
	}

	registerCanvasOpeners() {
		this.registerRemoteControlledComponent(this.registrableRemoteComponentsPrefixes.navCanvas, 'click', (name) => {
			if(UIkit.toggle('#' + name)){
				UIkit.toggle('#' + name).toggle()
			}
		});
	}
}

export default new App();
